import type { Invoice } from './bookings'

export function canExtendDueDate(invoice: Invoice): boolean {
  if (invoice.status === 'sent') return true
  if (invoice.status === 'partially_paid') return invoice.paymentMethod !== 'stripe'
  return false
}

export function hasUnacknowledgedProviderVoidFailure(invoice: Invoice): boolean {
  return Boolean(invoice.providerVoidFailedAt) && !invoice.providerVoidAcknowledgedAt
}
